import { render, staticRenderFns } from "./ProcessNewRequest.vue?vue&type=template&id=213fd018&scoped=true&"
import script from "./ProcessNewRequest.vue?vue&type=script&lang=js&"
export * from "./ProcessNewRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213fd018",
  null
  
)

export default component.exports